export const MM_PER_PIXELS = 25.4 / 96;
export const PIXELS_PER_MM = 96 / 25.4;